var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('img',{attrs:{"src":require("../assets/image/not-found.png"),"alt":""}}),_c('div',{staticClass:"tip"},[_vm._v(" 功能暂未开放 ")]),_c('div',{staticClass:"sub-tip"},[_vm._v(" 如有疑问请联系客服 ")])])
}]

export { render, staticRenderFns }